import React from 'react'

import {
    TeamMemberBoxDiv,
    TeamMemberBoxContentsDiv,
    TeamMemberTitleDiv,
    TeamMemberImageDiv,
    TeamMemberNameDiv,
    TeamMemberSocialsDiv,
    TeamMemberTitleText,
    TeamMemberNameText,
    SocialsDiv,
    SocialImage,
    TeamMemberImage
} from '../../Styles/Components/TeamMemberBoxStyles.js'

function TeamMemberBox(props){
    var tmTitle = props.tmTitle
    var tmName = props.tmName
    var tmPersonalSite = props.tmPersonalSite !== "" ? props.tmPersonalSite : null
    var tmSocials = props.tmSocials
    var tmImage = props.tmImage
    var socialsIconsLinks = props.socialsIconsLinks

    return (
        <TeamMemberBoxDiv>
            <TeamMemberBoxContentsDiv>
                <TeamMemberTitleDiv>
                    <TeamMemberTitleText>{tmTitle}</TeamMemberTitleText>
                </TeamMemberTitleDiv>
                <TeamMemberImageDiv>
                    <a href={tmPersonalSite} target="_blank" rel="noopener noreferrer">
                        <TeamMemberImage src={tmImage} />
                    </a>
                </TeamMemberImageDiv>
                <TeamMemberNameDiv>
                    <TeamMemberNameText>{tmName}</TeamMemberNameText>
                </TeamMemberNameDiv>
                <TeamMemberSocialsDiv>
                    {Object.keys(tmSocials).map(key => 
                        <SocialsDiv key={key}>
                            <a href={tmSocials[key]} target="_blank" rel="noopener noreferrer">
                                <SocialImage alt={key} src={socialsIconsLinks[key]} />
                            </a>
                        </SocialsDiv>
                    )}
                </TeamMemberSocialsDiv>
            </TeamMemberBoxContentsDiv>
        </TeamMemberBoxDiv>
    )
}

export default TeamMemberBox